module.exports = __webpack_public_path__ + "img/大模型算法.2eaabaeb.png";